<template><div><h1 id="mandanten" tabindex="-1"><a class="header-anchor" href="#mandanten"><span>Mandanten</span></a></h1>
<p>Mandanten — Definition der verfügbaren Mandanten</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Definition der im System verfügbaren Mandanten. Sämtliche Buchhaltungsdaten werden immer mit einem Mandanten versehen und erlauben das Führen mehrerer Mandanten auf Buchhaltungsebene. Innerhalb von funtrade stehen ebenfalls einige Auswertungen auf Mandantenebene zur Verfügung, die Trennung ist aber auf Systemebene nicht eindeutig.</p>
<p>Pfad: <code v-pre>Buchhaltung → Tabellen → Mandanten</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Mandant</dt>
<dd>Kürzel für Mandant, 1-stellig, alphanumerisch</dd>
<dt>MWSt-Ident</dt>
<dd>Mehrwertsteuernummer</dd>
<dt>Bezeichnung</dt>
<dd>Bezeichnung für Mandant</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/buchhaltung/debitorenverwaltung.html" title="Kapitel 6. Buchhaltung">Buchhaltung</RouteLink>--&gt;</p>
</div></template>


